class Subnav {
  constructor(nav) {
    this.nav = nav;
    this.links = [...nav.querySelectorAll(".subnav__link")].filter((a) => {
      try {
        const url = new URL(a.href, location.href);
        return url.pathname === location.pathname && url.hash.length > 1;
      } catch {
        return false;
      }
    });

    if (!this.links.length) return;

    this.sections = this.links
      .map((a) => {
        const id = new URL(a.href, location.href).hash.slice(1);
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (!this.sections.length) return;

    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: "0px 0px -50% 0px",
      threshold: 0,
    });

    this.visible = new Set();
    this.sections.forEach((s) => this.observer.observe(s));
  }

  onIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.visible.add(entry.target.id);
      } else {
        this.visible.delete(entry.target.id);
      }
    });

    // Z viditelných sekcí vyber tu s nejvyšším offsetTop (nejhlouběji na stránce)
    // – správně detekuje vnořené elementy (např. #zakladatele uvnitř #hodnoty)
    let activeId = null;
    let maxTop = -Infinity;
    this.sections.forEach((s) => {
      if (this.visible.has(s.id) && s.offsetTop > maxTop) {
        maxTop = s.offsetTop;
        activeId = s.id;
      }
    });

    this.links.forEach((a) => {
      const id = new URL(a.href, location.href).hash.slice(1);
      a.classList.toggle("is-active", id === activeId);
    });
  };
}

document.querySelectorAll(".subnav__nav").forEach((nav) => new Subnav(nav));
